module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BNDfkJ/tc-custom/9781035806515.jpg?1718183630371",
      "alt": "This image is the cover for the book The Creator's Vassal Heirs of Meridius"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Creator's Vassal Heirs of Meridius\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The first blow has fallen in the war against the Notandi. As the fragile peace in the Kingdom of Meridius begins to fracture, the demons’ counterattack could shatter it. "), _c('br'), _vm._v("Yecats Ratiug, also known as the Creator’s Vassal, has committed his life to ridding his homeland of the demon scourge. One man alone is not enough in such a crusade, and he finds assistance from an unlikely ally – a group that has been considered a myth for generations. "), _c('br'), _vm._v("To the north, Relyt and his companion Prince Mason have fled the slavers of Chelawin, seeking a way home. But it seems that not even royalty can escape the cruel whims of fate, as they are forced to survive in a blood-soaked land unfamiliar to either. "), _c('br'), _vm._v("Within the walls of Harmagin, Nagol spreads his ideas and gathers allies to his side, preparing for the inevitable arrival of his father to claim bloody vengeance for their exile. His faith in the cause is tested as he is confronted by the idea that his enemies may not be who he thought.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tyler Clarke\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0